// extracted by mini-css-extract-plugin
export var asideList = "courses-movie-group-module--aside-list--3926b";
export var emptyScreen = "courses-movie-group-module--empty-screen--24154";
export var fakeWrapperIconLock = "courses-movie-group-module--fake-wrapper-icon-lock--38fea";
export var iconLock = "courses-movie-group-module--icon-lock--a42b1";
export var notBoughtButtons = "courses-movie-group-module--not-bought-buttons--77c66";
export var pointsButtonWrapper = "courses-movie-group-module--points-button-wrapper--68afd";
export var ratioClass = "courses-movie-group-module--ratio-class--cf33a";
export var video = "courses-movie-group-module--video--8804c";
export var wrapper = "courses-movie-group-module--wrapper--14753";